import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';

import Breadcrumbs from '../../breadcrumbs';
import {Wrapper} from 'system/wrapper';
import {List} from './components';
import Input from 'form/input';
import Pagination from 'pagination';

import {UniversalSearchWrapper} from 'components/common';
import Spinner from 'spinner';
import {ButtonDefault} from 'components/buttons';

import {searchServices} from 'redux/actions/portal/services';

import service from 'images/general/poslugi.svg';

const mapStateToProps = (state) => ({
  services: state.services.get('servicesList'),
  isLoading: state.services.get('servicesIsLoading')
});

const mapDispatchToProps = (dispatch) => ({
  onSearch: (name, offset) => dispatch(searchServices(name, 12, offset))
});

class Services extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: ""
    }

    this.changeSearchName = this.changeSearchName.bind(this);
  }

  changeSearchName(event) {
    this.setState({
      name: event.target.value
    })
  }

  generateServices = services => services.map((item, i) => {
    return (
      <li key={i}>
        <Link to={`/services/detail/${item.get('id')}`}>
          <img src={service} alt="Послуги"/>
          <h3>{item.get('title')}</h3>
        </Link>
      </li>
    )
  })

  onSubmitForm = event => {
    event.preventDefault();
    const page = this.props.match.params.page || 1;
    const offset = 12 * (page - 1);
    page != 1
      ? this.props.history.push(`/services/1`)
      : this.props.onSearch(this.state.name, offset)
  }

  renderServicesList = () => this.props.services.get('results').size === 0
    ? <h3>Послуги відсутні</h3>
    : <div><List>{this.generateServices(this.props.services.get('results'))}</List></div>

  componentDidMount() {
		const page = this.props.match.params.page || 1;
		const offset = 12 * (page - 1);
		this.props.onSearch(this.state.name, offset)
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.match.params.page !== nextProps.match.params.page) {
			const page = nextProps.match.params.page || 1;
			const offset = 12 * (page - 1);
			this.props.onSearch(this.state.name, offset)
		}
	}

  render() {

    if (this.props.services === undefined) {
      return (
        <Wrapper>
          <Spinner/>
        </Wrapper>
      )
    }

    return(
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/services">Послуги</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>Послуги</h2>
            <UniversalSearchWrapper onSubmit={this.onSubmitForm}>
              <Input
                block
                placeholder="Введіть назву послуги"
                label="Пошук за назвою послуги"
                value={this.state.name}
                onChange={this.changeSearchName}
              />
              <ButtonDefault type="submit" value="Пошук" />
            </UniversalSearchWrapper>
            {this.props.isLoading ? (
              <Spinner />
            ):
              this.renderServicesList()
            }

            <Pagination counts={this.props.services.get('count')} path={`/services/`} matched={this.props.match.params.page} limits={12}/>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Services));



// WEBPACK FOOTER //
// ./src/system/main/services/index.js